import React, { useCallback, useState } from 'react';
import Gallery from 'react-photo-gallery';
import cn from 'classnames';
import useInfoPreviews from '../../../../queries/useInfoPreviews';
import generateUrlFromBlob from '../../../../../../helpers/generateUrlFromBlob';
import SelectedImage from '../SelectedImg/SelectedImg';
import { Lightbox } from '../../../../../../modal_image';
import { getInfoAttachData } from '../../../../requests/getInfoAttachData';
import styles from './PreviewGallery.module.scss';

const PreviewGallery = ({ rawImages, infoId, onDelete }) => {
  const [lightboxVisible, setLightboxVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const handleOpenLightbox = useCallback(async (photo) => {
    setLightboxVisible(true);

    const fileName = photo['data-file-name'];
    const name = photo.name;

    const imgStr = await getInfoAttachData(infoId, fileName, 'attachment');
    const url = generateUrlFromBlob(imgStr);

    const img = new Image();
    img.src = url;
    img.alt = name;

    setCurrentImage(img);
  }, []);

  const handleCloseLightbox = () => {
    setLightboxVisible(false);
    setCurrentImage(null);
  };

  const previewsData = useInfoPreviews({ rawImages, infoId });

  let images = [];

  if (previewsData.every((img) => img.isSuccess)) {
    previewsData.forEach((preview, index) => {
      if (preview.data) {
        const { name, fileName, id } = rawImages[index] || {};

        const url = generateUrlFromBlob(preview.data);

        images.push({
          src: url,
          alt: name,
          name: name,
          'data-file-name': fileName,
          'data-attach-id': id,
          width: index % 2 ? 1 : 4,
          height: index % 2 ? 1 : 3,
        });
      }
    });
  }

  const renderImage = useCallback(
    ({ index, left, top, key, photo }) => {
      return (
        <SelectedImage
          key={key}
          margin="2px"
          index={index}
          photo={photo}
          left={left}
          top={top}
          onClick={handleOpenLightbox}
          onDelete={onDelete}
        />
      );
    },
    [onDelete]
  );

  return images.length ? (
    <div
      className={cn(styles.root, {
        [styles.one]: images?.length < 2,
        [styles.multiple]: images?.length >= 2,
      })}
    >
      <Gallery renderImage={renderImage} photos={images} />
      {lightboxVisible && (
        <Lightbox
          medium={currentImage?.src || null}
          large={currentImage?.src || null}
          showRotate={true}
          alt={currentImage?.alt || ''}
          onClose={handleCloseLightbox}
        />
      )}
    </div>
  ) : null;
};

export default PreviewGallery;
